module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_609.f29f44e5.png";